import axios from '../config/axios'

export const getPrivacy = ()=> axios.get(`/rest/participant/open/privacy-policy`)
export const getTerms = ()=> axios.get(`/rest/participant/open/term-condition`)
export const getFaq = ()=> axios.get(`/rest/participant/open/faq`)